import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CuttingToolConfigState } from "@theStellarBlueprint/Store/Data/CuttingToolConfig/CuttingToolConfigState";
import { Draft } from "immer";

const initialCuttingToolConfigState: CuttingToolConfigState = {
    attributeValueIds: [],
};

const reducer = {
    "Custom/CuttingToolConfig/PopulateCuttingToolConfigParam": (draft: Draft<CuttingToolConfigState>) => {},
    "Custom/CuttingToolConfig/CleanCuttingToolConfig": (draft: Draft<CuttingToolConfigState>) => {
        draft.attributeValueIds = [];
    },

    "Custom/CuttingToolConfig/SetCuttingToolConfig": (
        draft: Draft<CuttingToolConfigState>,
        action: { result: CuttingToolConfigState },
    ) => {
        draft.attributeValueIds = action.result.attributeValueIds;
    },
};

export default createTypedReducerWithImmer(initialCuttingToolConfigState, reducer);
